import { createAsyncThunk } from '@reduxjs/toolkit';
import i18n from 'i18n';
import {
  requestReferralHistory,
  requestReferralLinks,
  requestReferralStats,
} from 'store/api/cuverse-api/affiliate/affiliate.service';
import {
  ReferralStatsResponseSchema,
  TReferralStatsData,
} from 'store/api/cuverse-api/affiliate/types/affiliate-referral-stats-response.interface';
import {
  ReferralHistoryResponseSchema,
  TReferralHistoryData,
} from 'store/api/cuverse-api/affiliate/types/referral-history-response.interface';
import {
  ReferralLinksResponseSchema,
  TReferralLinksData,
} from 'store/api/cuverse-api/affiliate/types/referral-links-response.interface';

import { requestWithZodSchema } from 'utils/common/requestWithZodSchema';
import { notifyError } from 'utils/notify/notify.utils';

export const fetchReferralStatsThunkAction = createAsyncThunk(
  'affiliate/fetchReferralsStats',
  async (): Promise<TReferralStatsData> => {
    return await requestWithZodSchema(requestReferralStats, ReferralStatsResponseSchema)
      .then((response) => response)
      .catch((error) => {
        notifyError(i18n.t('notifyMessages.affiliate.statsLoadError'));
        throw error;
      });
  },
);

export const fetchReferralLinksThunkAction = createAsyncThunk(
  'affiliate/fetchReferralLinks',
  async (): Promise<TReferralLinksData> => {
    return await requestWithZodSchema(requestReferralLinks, ReferralLinksResponseSchema)
      .then((response) => {
        const linkKey = Object.keys(response)[0];

        return response[linkKey];
      })
      .catch((error) => {
        notifyError(i18n.t('notifyMessages.affiliate.linkLoadError'));
        throw error;
      });
  },
);

export const fetchReferralHistory = createAsyncThunk(
  'affiliate/referralHistory',
  async (): Promise<TReferralHistoryData> => {
    return await requestWithZodSchema(requestReferralHistory, ReferralHistoryResponseSchema)
      .then((response) => response)
      .catch((error) => {
        notifyError(i18n.t('notifyMessages.affiliate.historyLoadError'));
        throw error;
      });
  },
);
